import { Button } from '@/components/ui/button';
import { Star, X } from 'lucide-react';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const CompareManufacturers = ({
  onClose,
  screen,
  bookmarks,
  toggleBookmark,
  selectedToCompare,
  toggleSelect,
}) => {
  const navigate = useNavigate();
  const [manufacturerData, setManufacturerData] = useState(selectedToCompare);
  const handleRemove = (manufacturer, indexToRemove) => {
    setManufacturerData((prev) =>
      prev.filter((_, index) => index !== indexToRemove),
    );

    toggleSelect(manufacturer);
  };

  useEffect(() => {
    if (manufacturerData.length === 0) {
      onClose();
    }
  }, [manufacturerData]);

  return (
    <div className="p-4 overflow-x-auto overflow-y-auto mb-4">
      <h2 className="text-lg font-medium mb-6">Comparing the Selections</h2>
      <div
        className="inline-grid text-sm w-full"
        style={{
          gridTemplateColumns: `220px repeat(${manufacturerData.length}, minmax(250px, 1fr))`,
        }}
      >
        {/* Top headers */}
        <div className="h-52" /> {/* Empty top-left cell */}
        {manufacturerData.map((m, idx) => {
          const isBookmarked =
            screen === 'SHORTLIST'
              ? true
              : bookmarks.some(
                  (bookmark) => bookmark.manufacturer_id === m.manufacturer_id,
                );
          return (
            <div
              key={idx}
              className={`relative flex flex-col items-center justify-center px-4 border-r border-t ${idx === 0 && 'border-l'} border-gray-200`}
            >
              <button
                className="absolute right-1 top-1 p-1 text-gray-500 rounded-full hover:shadow-md transition-all ease-in duration-300"
                onClick={() => handleRemove(m, idx)}
              >
                <X className="h-5 w-5" />
              </button>
              <div className="flex gap-4 mb-6 items-center">
                <img
                  src="https://www.google.com/images/branding/googlelogo/2x/googlelogo_light_color_272x92dp.png"
                  alt="Logo"
                  className="w-12 h-12 border"
                />
                <div className="flex items-center justify-between w-full">
                  <h3 className="text-base font-semibold">{m?.company_name}</h3>
                </div>
              </div>
              <div className="mt-2 flex justify-center items-center space-x-2 w-full">
                <Button
                  className="bg-white w-[180px] text-darkPurple rounded border border-darkPurple hover:text-darkerPurple hover:bg-veryLightPurple/10"
                  onClick={(e) => {
                    e.stopPropagation();
                    navigate(`/manufacturer/${m.manufacturer_id}`);
                  }}
                >
                  View Details
                </Button>
                <button
                  className={`p-2 bg-white text-gray-600 ${screen !== 'SHORTLIST' && 'hover:shadow'} rounded transition-all ease-in duration-300`}
                  onClick={() => {
                    if (screen !== 'SHORTLIST') toggleBookmark(m);
                  }}
                  disabled={screen === 'SHORTLIST'}
                >
                  <Star
                    className={`h-6 w-6 transition-all duration-200 ${
                      isBookmarked
                        ? 'fill-darkPurple text-darkPurple'
                        : 'text-black'
                    }`}
                  />
                </button>
              </div>
            </div>
          );
        })}
        {/* Rating & Reviews */}
        {/* <div className="font-medium border-t border-b border-gray-200 py-3 px-4 bg-gray-50">
          Rating & Reviews
        </div>
        {manufacturerData.map((m, i) => (
          <div
            key={`rating-${i}`}
            className="flex items-center space-x-1 border-t border-b border-gray-200 px-4 py-3"
          >
            {[...Array(5)].map((_, j) => (
              <span
                key={j}
                className={`text-yellow-400 text-sm ${j < Math.floor(m.rating) ? '' : 'opacity-40'}`}
              >
                ★
              </span>
            ))}
            <span className="text-sm text-gray-500 ml-2">
              Reviews({m.reviews})
            </span>
          </div>
        ))} */}
        {/* Attribute rows */}
        {[
          { label: 'Location', key: 'country' },
          { label: 'Capacity', key: 'capacity' },
          { label: 'Experience', key: 'experience' },
          { label: 'Capability', key: 'capability' },
          { label: 'Avg. Lead Time', key: 'leadTime' },
          { label: 'Certifications', key: 'certifications' },
        ].map((attr, i) => (
          <React.Fragment key={i}>
            <div
              className={`text-center font-semibold border-t border-r border-gray-200 py-3 px-4 ${i % 2 !== 0 && 'bg-gray-50'}`}
            >
              {attr.label}
            </div>
            {manufacturerData.map((m, j) => (
              <div
                key={`${attr.key}-${j}`}
                className={`border-t border-r border-gray-200 py-4 px-6 text-gray-700 text-center ${i % 2 !== 0 && 'bg-gray-50'}`}
              >
                {(m[attr.key] && m[attr.key]) || '--'}
              </div>
            ))}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default CompareManufacturers;
